/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Autocomplete(theme: Theme): any {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: { boxShadow: theme.customShadows.z20 },
        popper: { zIndex: 1301, minWidth: 250 },
        tag: { height: "auto" },
      },
    },
  };
}
